var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSbp = function SvgSbp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.5156L7.09134 13.0523V10.9398L5.00245 7.48327L5 16.5156Z",
    fill: "#5B57A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0298 14.3134L14.9895 15.4262L19 15.4297L13.0298 12.0412L13.0298 14.3134Z",
    fill: "#D90751"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0184 16.5377L13.0295 11.9524L10.9333 13.1458V20L13.0184 16.5377Z",
    fill: "#FAB718"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15.4297L14.9895 15.4262L13.0184 16.5377L10.9333 20L19 15.4297Z",
    fill: "#ED6F26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0295 7.46601V9.69067L10.9333 10.8613L10.9344 4.00029L13.0295 7.46601Z",
    fill: "#63B22F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9847 8.56673L7.09134 13.0523L5 16.5156L18.9916 8.57126L14.9847 8.56673Z",
    fill: "#1487C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9343 4.00131L13.0291 7.46702L14.9839 8.56969L18.9909 8.57422L10.9343 4.00131Z",
    fill: "#017F36"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00245 7.48327L10.9511 10.8595L8.95129 11.9963L7.09134 10.9398L5.00245 7.48327Z",
    fill: "#984995"
  })));
};
export default SvgSbp;